import SwishError from './SwishError';

export default class UnknownError extends SwishError {
  isUnknownError() { return true; }
}
